import React from 'react'

const Manual_regalo_punch_cards = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Crear regalo de Punch Cards
        </h2>
        <iframe
          src="https://scribehow.com/embed/Crear_regalo_de_Punch_Cards__O3a_cMdnQB-aQ6e4YIKcaA?as=scrollable"
          className="scribe-iframe-general-142"
          width="100%"
          height="12000"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_regalo_punch_cards
